var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('vs-breadcrumb',{staticClass:"block mb-2 resources-breadcrumb",attrs:{"items":_vm.populateBreadcrumbs}}),_c('div',{staticClass:"nurseResources-wrapper flex flex-col items-center space-y-6"},[_c('Filters'),_c('SearchResults')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }